// import React, { useState, useEffect } from "react";
// import simplifyingLogo from "../../images/simplifyinglogo.png";
// import { Link, useNavigate, useLocation } from "react-router-dom";

// const Desktop = () => {
//   const [activeSkill, setActiveSkill] = useState(false);
//   const [activeNextgenJ, setActiveNextgenJ] = useState(false);
//   const [activeNextgenI, setActiveNextgenaI] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation(); // Hook to get the current route

//   // Reset active states when the route changes
//   useEffect(() => {
//     const path = location.pathname;
//     if (path !== "/skillsphere-assessment" && path !== "/nextgeni" && path !== "/nextgenj") {
//       setActiveSkill(false);
//       setActiveNextgenJ(false);
//       setActiveNextgenaI(false);
//     }
//   }, [location.pathname]); // Trigger effect when the route changes

//   const handleActiveSkill = () => {
//     setActiveSkill(true);
//     setActiveNextgenJ(false);
//     setActiveNextgenaI(false);
//   };

//   const handleActiveInnovator = () => {
//     setActiveSkill(false);
//     setActiveNextgenJ(false);
//     setActiveNextgenaI(true);
//   };

//   const handleActiveJunior = () => {
//     setActiveSkill(false);
//     setActiveNextgenJ(true);
//     setActiveNextgenaI(false);
//   };

//   return (
//     <nav className="bg-blue-600 shadow-md flex items-center pt-2 w-screen z-50" style={{ position: "sticky", top: 0 }}>
//       <div className="h-4 bg-blue-950 absolute top-0 left-0 w-5/6 -z-0 rounded-br-3xl"></div>

//       <Link to="/">
//         <div className="flex items-center h-full z-10 bg-white rounded-tr-3xl overflow-hidden">
//           <img src={simplifyingLogo} alt="Logo" className="h-full w-52" />
//         </div>
//       </Link>

//       <div className="flex-1 flex mx-6">
//         <div>
//           <Link to="/skillsphere-assessment">
//             <button
//               onClick={handleActiveSkill} style={{fontFamily: "Montserrat" }}
//               className={`px-4 py-2 ${
//                 activeSkill ? "bg-gray-200 text-black" : "hover:bg-gray-200 hover:text-black text-white"
//               } cursor-pointer rounded-md md:w-[110px] md:text-[12px] lg:text-[15px] lg:w-fit`} 
//             >
//               SKILLSPHERE ASSESSMENT
//             </button>
//           </Link>
//           <Link to="/nextgeni">
//             <button
//               onClick={handleActiveInnovator} style={{fontFamily: "Montserrat" }}
//               className={`px-4 py-2 ${
//                 activeNextgenI ? "bg-gray-200 text-black" : "hover:bg-gray-200 hover:text-black text-white"
//               } cursor-pointer rounded-md md:w-[120px] lg:w-fit md:text-[12px] lg:text-[15px]`}
//             >
//               NEXTGEN INNOVATORS
//             </button>
//           </Link>
//           <Link to="/nextgenj">
//             <button
//               onClick={handleActiveJunior} style={{fontFamily: "Montserrat" }}
//               className={`px-4 py-2 ${
//                 activeNextgenJ ? "bg-gray-200 text-black" : "hover:bg-gray-200 hover:text-black text-white"
//               } cursor-pointer rounded-md md:w-[120px] lg:w-fit md:text-[12px] lg:text-[15px]`}
//             >
//               NEXTGEN JUNIORS
//             </button>
//           </Link>
//         </div>
//       </div>

//       <div className="flex justify-center">
//         <button style={{fontFamily: "Montserrat" }}
//           className="bg-blue-900 absolute right-[5%] bottom-4 text-white px-4 py-2 rounded-md md:mr-[7%] font-bold mr-2 hover:bg-[#130f40]"
//           onClick={() => navigate("/contact")}
//         >
//           CONTACT US
//         </button>
//       </div>

//       <div className="flex items-center gap-x-3">
//         <a
//           target="_blank" style={{fontFamily: "Montserrat" }}
//           href="https://skillsphere.simplifyingskills.com/login"
//           className="bg-blue-900 text-white xl:px-4 md:px-3 py-2 absolute hover:bg-[#130f40] rounded-md font-bold right-[4%] mr-2"
//         >
//           LOGIN
//         </a>
//       </div>
//     </nav>
//   );
// };

// export default Desktop;
import * as React from 'react';
import {
  Box, Typography, Button, Menu, MenuItem, Divider,
} from '@mui/material';
import { styled } from '@mui/system';
import { Link, useNavigate } from 'react-router-dom';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SchoolIcon from '@mui/icons-material/School';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import BrushIcon from '@mui/icons-material/Brush';
import BusinessIcon from '@mui/icons-material/Business';
import FeedIcon from '@mui/icons-material/Feed';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import GavelIcon from '@mui/icons-material/Gavel';
import BadgeIcon from '@mui/icons-material/Badge';
import CompostIcon from '@mui/icons-material/Compost';
import RadioIcon from '@mui/icons-material/Radio';
import CastleIcon from '@mui/icons-material/Castle';
import { useTheme, useMediaQuery } from "@mui/material";
import GlassIcons from './GlassIcon';

const NavLink = styled(Typography)({
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  fontWeight: 500,
  color: '#222',
  '&:hover': {
    color: '#1d4ed8',
    transform: 'scale(1.05)',
    textShadow: '0 0 3px rgba(126, 168, 255, 0.4), 0 0 6px rgba(94, 158, 255, 0.3)',
  },
});

// ✅ UPDATED COMPONENT
const DropdownContent = ({ items, handleClose }) => (
  <>
    <Typography style={{ fontFamily: 'Montserrat', fontWeight: '500' }}>Explore the Options</Typography>
    <Divider />
    {items.map(({ icon, title, subtitle, route, color }) => (
      <MenuItem
        key={title}
        onClick={() => {
          handleClose();
          if (route) {
            window.location.href = route;
          }
        }}
        disabled={!route}
        style={{
          opacity: route ? 1 : 0.5,
          cursor: route ? 'pointer' : 'not-allowed',
        }}
      >
        <GlassIcons items={[{ icon, label: title, color }]} />
        <Box ml={1}>
          <Typography fontWeight={700} fontSize="15px">{title}</Typography>
          {subtitle && <Typography fontSize="12px">{subtitle}</Typography>}
        </Box>
      </MenuItem>
    ))}
  </>
);

export default function New_header_Desktop() {
  const navigate = useNavigate();
  const theme = useTheme();
  const istab = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = React.useState({
    products: null,
    courses: null,
    clubs: null,
    community: null,
  });

  const handleMenuClick = (menu) => (event) => {
    setAnchorEl({
      products: null,
      courses: null,
      clubs: null,
      community: null,
      [menu]: event.currentTarget,
    });
  };

  const handleMenuClose = (menu) => () => {
    setAnchorEl(prev => ({ ...prev, [menu]: null }));
  };

  const menus = {
    products: [
      {
        icon: <SchoolIcon />, title: 'Class 1-5',
        subtitle: 'Learn Smart with Theme-Based Learning', color: '#0984E3', route: '/nextgenj'
      },
      {
        icon: <CastForEducationIcon />, title: 'Class 6-10',
        subtitle: 'Learn Smart with Skill-Based Learning', color: '#0984E3', route: '/nextgeni'
      },
      {
        icon: <CastleIcon />, title: 'University',
        subtitle: 'From Campus To Corporate', color: '#0984E3', route: '/campus'
      },
      {
        icon: <BadgeIcon />, title: 'Corporate',
        subtitle: 'Where Placement Meets Purpose', color: '#0984E3', route: '/nextgenPlacement'
      },
      {
        icon: <AssessmentIcon />, title: 'Assessment Center',
        subtitle: 'Skillsphere Assessment', color: '#0984E3', route: '/'
      },
    ],
    clubs: [
      {
        icon: <BusinessCenterIcon />, title: 'Entrepreneurship League',
        color: '#4b7bec', route: '/entrepreneurship'
      },
      {
        icon: <PrecisionManufacturingIcon />, title: 'Engineering Explorers',
        color: '#4b7bec', route: '/engineeringexplorers'
      },
      {
        icon: <VaccinesIcon />, title: 'Medical Mavericks',
        color: '#4b7bec', route: '/medicalmavericks'
      },
      {
        icon: <BrushIcon />, title: 'Artistic Visionaries',
        color: '#4b7bec', route: '/artisticvisionaries'
      },
      {
        icon: <BusinessIcon />, title: 'Business Trailblazers',
        color: '#4b7bec', route: '/businesstrailbazars'
      },
      {
        icon: <GavelIcon />, title: 'Administrative Achievers',
        color: '#4b7bec', route: '/administrativeAchievers'
      },
      // {
      //   icon: <CompostIcon />, title: 'Sustainability & Green Innovation Club',
      //   color: '#4b7bec'
      // },
      // {
      //   icon: <RadioIcon />, title: 'Media, Communication & Influence Club',
      //   color: '#4b7bec'
      // },
    ],
    community: [
      {
        icon: <FeedIcon />, title: 'Blogs',
        color: '#0984E3', route: '/blog'
      },
    ],
  };

  return (
    <Box sx={{
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'transparent',
      py: 2,
    }}>
      <Box sx={{
        width: '95vw',
        backgroundColor: '#F4F7FF',
        borderRadius: '25px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 4,
        py: 1,
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
      }}>
        {/* Left Section */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '3rem' }}>
          <Link to="/home">
            <Box component="img" src="https://dbqa318yoj3nn.cloudfront.net/SIMPLIFYING%20SKILLS%201.png" alt="Logo" sx={{ height: '35px' }} />
          </Link>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
            {['products', 'clubs', 'community'].map((key) => (
              <React.Fragment key={key}>
                <Button
                  style={{ borderRadius: '25px' }}
                  onClick={handleMenuClick(key)}
                >
                  <Typography style={{
                    color: '#000',
                    fontFamily: 'Montserrat',
                    fontWeight: '500',
                    textTransform: 'none',
                  }}>
                    {key.charAt(0).toUpperCase() + key.slice(1)} <KeyboardArrowDownRoundedIcon style={{ color: '#b2bec3' }} />
                  </Typography>
                </Button>
                <Menu
                  anchorEl={anchorEl[key]}
                  open={Boolean(anchorEl[key])}
                  onClose={handleMenuClose(key)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  slotProps={{ paper: { sx: { mt: 1.5, borderRadius: '10px', padding: '10px' } } }}
                >
                  <DropdownContent items={menus[key]} handleClose={handleMenuClose(key)} />
                </Menu>
              </React.Fragment>
            ))}
            {/* Direct navigation for Packages */}
            <Button
              key="packages"
              style={{ borderRadius: '25px' }}
              onClick={() => navigate('/Packages')}
            >
              <Typography style={{
                color: '#000',
                fontFamily: 'Montserrat',
                fontWeight: '500',
                textTransform: 'none',
              }}>
                Packages
              </Typography>
            </Button>
          </Box>
        </Box>

        {/* Contact Button */}
        <button
          onClick={() => navigate('/contact')}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 14px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.92)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: 'linear-gradient(to bottom right, #3479FFCF, #468eff)',
            border: 'none',
            borderRadius: '30px',
            padding: '10px 24px',
            color: '#fff',
            fontWeight: 500,
            fontSize: '16px',
            fontFamily: 'Segoe UI, sans-serif',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
            cursor: 'pointer',
            transition: 'transform 0.15s ease, box-shadow 0.2s ease',
            outline: 'none',
          }}
        >
          <PhoneRoundedIcon style={{ color: 'white', fontSize: 24 }} />
          Contact
        </button>
      </Box>
    </Box>
  );
}
